import { AbstractValidator } from './abstract-validator';

export class NumberValidator extends AbstractValidator {
    static getIdentifier() {
        return 'number';
    }
    static isApplicable(input, validationInstance) {
        return super.isApplicable(input, validationInstance)
            && (input.getAttribute('type') === 'number' || input.matches(`[data-validate~="${this.getIdentifier()}"]`));
    }
    static validate(input) {
        return (onError, onSuccess) => {
            if (/^[0-9]+$/.test(input.value)) {
                onSuccess();
            } else {
                onError();
            }
        };
    }
}